import { Route, Routes, useLocation } from 'react-router-dom';
import { SideNav } from 'src/common/components/SideNav';

import { PhoneAnalyticsStandalone } from './components/PhoneAnalyticsStandalone';
import { ReportsDashboardStandalone } from './components/ReportsDashboardStandalone';
import { TabulationsDashboardStandalone } from './components/TabulationsDashboardStandalone';
import { Dashboard } from './dashboard';
import { AccountDetailPage } from './pages/AccountDetailPage';
import { CreateAccountPage } from './pages/CreateAccountPage';
import { DidRouting } from './pages/DidRouting';
import { FreeSwitchGroups } from './pages/FreeSwitchGroups';
import { RingStrategies } from './pages/RingStrategies';
import { SipTrunks } from './pages/SipTrunks';

const MENU = [
  { title: 'Cuentas', url: '/app/phone_settings', icon: 'building' },
  { title: 'SIP Trunks', url: '/app/phone_settings/sip_trunks', icon: 'cloud' },
  { title: 'FS Groups', url: '/app/phone_settings/fs_groups', icon: 'server' },
  { title: 'DID Routing', url: '/app/phone_settings/did_routing', icon: 'phone' },
  { title: 'Ring Strategies', url: '/app/phone_settings/ring_strategies', icon: 'workflow' },
];

export const PhoneSettings: React.FC = () => {
  const location = useLocation();

  // Full-screen pages without the SideNav
  const isCreateAccountPage =
    location.pathname.includes('/phone_settings/accounts/create') ||
    location.pathname.includes('/phone-settings/accounts/create');

  // Match /phone_settings/accounts/:id and /phone-settings/accounts/:id where :id is a number
  const isAccountDetailPage = /\/phone[_-]settings\/accounts\/\d+/.test(location.pathname);

  if (isCreateAccountPage || isAccountDetailPage) {
    return (
      <Routes>
        <Route path="/accounts/create" element={<CreateAccountPage />} />
        <Route path="/accounts/:accountId" element={<AccountDetailPage />} />
      </Routes>
    );
  }

  return (
    <div className="flex h-full">
      <SideNav items={MENU} />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/sip_trunks" element={<SipTrunks />} />
          <Route path="/fs_groups" element={<FreeSwitchGroups />} />
          <Route path="/did_routing" element={<DidRouting />} />
          <Route path="/ring_strategies" element={<RingStrategies />} />
          <Route path="/analytics/:accountId" element={<PhoneAnalyticsStandalone />} />
          <Route path="/reports/:accountId" element={<ReportsDashboardStandalone />} />
          <Route path="/tabulations/:accountId" element={<TabulationsDashboardStandalone />} />
        </Routes>
      </div>
    </div>
  );
};
